import { useTranslation } from 'next-i18next'
import React from 'react'
import { Pressable, Text, TextInput, View } from 'react-native'

import { stepContent } from '@/components/flowStep/styles'
import type { useOtpFlow } from '@/hooks/useOtpFlow'

export const OtpModal = ({ otp }: { otp: ReturnType<typeof useOtpFlow> }) => {
  const { t } = useTranslation()
  const {
    otpOverlay,
    otpCard,
    otpHeader,
    otpTitle,
    otpCloseButton,
    otpDescription,
    otpErrorBox,
    otpErrorText,
    otpInput,
    otpResendButton,
    otpResendText,
    otpConfirmButton,
    otpConfirmText,
  } = stepContent()

  return (
    <View className={otpOverlay()}>
      <View className={otpCard()}>
        <View className={otpHeader()}>
          <Text className={otpTitle()}>{t('sharedFlows_common:otpLogin.title')}</Text>
          <Pressable onPress={otp.reset}>
            <Text className={otpCloseButton()}>✕</Text>
          </Pressable>
        </View>
        <Text className={otpDescription()}>
          {t('sharedFlows_common:otpLogin.description', { email: otp.email })}
        </Text>
        {otp.error ? (
          <View className={otpErrorBox()}>
            <Text className={otpErrorText()}>{otp.error}</Text>
          </View>
        ) : null}
        <TextInput
          value={otp.code}
          onChangeText={otp.setCode}
          placeholder={t('sharedFlows_common:otpLogin.codePlaceholder')}
          keyboardType="numeric"
          className={otpInput()}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        />
        <Pressable
          className={otpResendButton()}
          onPress={otp.handleResend}
          disabled={otp.resendDisabled}
        >
          <Text className={otpResendText({ resendDisabled: otp.resendDisabled })}>
            {t('sharedFlows_common:otpLogin.resend')}
          </Text>
        </Pressable>
        <Pressable
          className={otpConfirmButton()}
          onPress={otp.handleConfirm}
          disabled={otp.isVerifying || !otp.code.trim()}
        >
          <Text className={otpConfirmText()}>
            {otp.isVerifying
              ? t('sharedFlows_common:otpLogin.verifying')
              : t('sharedFlows_common:otpLogin.confirm')}
          </Text>
        </Pressable>
      </View>
    </View>
  )
}
